import { VIRGIN_VELOCITY_BURN_MINIMUM, VIRGIN_VELOCITY_BURN_RATE } from 'constants/partnerships'
import { areStringsEqual } from 'lib/string/stringUtils'

/**
 * Retrieves the number of points the user would earn with the partnership for the package
 * @param partnership The partnership to get the points for
 * @param basePrice The base price (pre-surcharges) of the pkg being purchased
 */
export function getRewardPoints(partnership: App.PackagePartnership, basePrice: number) {
  return Math.floor((partnership.localRewardConversionRate * basePrice) + partnership.bonusPoints)
}

/**
 * Retrieves the amount of points nicely formatted string the user needs to burn to
 * purchase the offer the conversion rate is: for every point I get 0.007 AUD
 * @param price Total Price
 */
export function getPriceInPoints(price: number): string {
  return Math.floor((price / 0.007)).toLocaleString()
}

export function getApplicableVelocityFeatures(price: number): { canEarn: boolean, canBurn: boolean } {
  return {
    canEarn: false,
    canBurn: price >= VIRGIN_VELOCITY_BURN_MINIMUM * VIRGIN_VELOCITY_BURN_RATE,
  }
}

export function doesVelocityEarnMatchTravellerDetails(travellerDetails: Array<App.Checkout.TravellerForm>, velocityDetails: { firstName: string, lastName: string }): boolean {
  return travellerDetails.some((traveller) => {
    return areStringsEqual(velocityDetails.firstName, traveller.firstName) &&
      areStringsEqual(velocityDetails.lastName, traveller.lastName)
  })
}
